import axiosClient, { cleanPayload } from "./axiosClient";
import { ApiResponse } from "models";

import { PaymentPayload, Payment } from "models/payment";

const paymentApi = {
  getPaymentList(data: any): Promise<Payment> {
    return axiosClient.get(`/paymentManage/getPayment`, {
      params: {
        page: data.page ? String(data.page) : undefined,
        limit: data.limit ? String(data.limit) : undefined,
        search: data.search,
        currency: data.region,
        sortField: data.sortName,
        sortType: data.sortType,
      }
    });
  },

  getPaymentById(data: PaymentPayload): Promise<Payment> {
    return axiosClient.get(`/paymentManage/getPayment`, {
      params: {
        _id: data.id,
        disablePagination: true,
      }
    });
  },
  addPayment(data: Payment): Promise<ApiResponse> {
    const url = `/paymentManage/addPayment`;
    return axiosClient.post(url, {
      invoiceNumber: data?.invoiceNumber,
      transactionId: data?.transactionId,
      paymentDate: data.paymentDate,
      paymentMethod: data.paymentMethod,
      paymentGateway: data.paymentGateway,
      status: data.status,
      amountPaid: data.amountPaid,
    });
  },

  updatePayment(data: Payment): Promise<ApiResponse> {
    const payload = cleanPayload({
      invoiceNumber: data.invoiceNumber,
      transactionId: data.transactionId,
      paymentDate: data.paymentDate,
      paymentMethod: data.paymentMethod,
      paymentGateway: data.paymentGateway,
      status: data.status,
      amountPaid: data.amountPaid,
    });

    return axiosClient.put<ApiResponse>(`/paymentManage/updatePayment`, payload, {
      params: { _id: data._id }
    });
  },

  getPaymentPdf(data: any): Promise<ApiResponse> {
    return axiosClient.get(`/paymentManage/getPaymentPdf`, {
      params: { paymentId: data._id }
    });
  },
  deletePayment(data: any): Promise<ApiResponse> {
    return axiosClient.delete(`/paymentManage/deletePayment`, {
      params: { _id: data._id }
    });
  },
  listAllInvoices(data: PaymentPayload): Promise<Payment> {
    return axiosClient.get(`/invoice/listAllInvoices`, {
      params: {
        page: data.page,
        limit: data.limit,
        search: data.search,
        currency: data.region,
        sortField: data.sortName,
        sortType: data.sortType,
        isPaymentInvoiceNumber: true
      }
    });
  },
};

export default paymentApi;
